<template>
  <div
    id="settings-view"
    class="flex"
    :class="{'announcement-space': showAnnouncement }">
    <div class="settings-menu">
      <!-- MEMBER section -->
      <h5>Account settings</h5>

      <router-link
        :to="{ name: 'ProfileInfo' }"
        exact
        tag="p"
        class="list-item" >
        Profile info
      </router-link>

      <router-link
        :to="{ name: 'Email' }"
        exact
        tag="p"
        class="list-item" >
        Email address
      </router-link>

      <router-link
        :to="{ name: 'Password' }"
        exact
        tag="p"
        class="list-item" >
        Password
      </router-link>

    </div>
    <router-view class="settings-content greedy" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import store from '@/store';
import SettingsNavMixin from '@/mixins/SettingsNav';
import SBColors from '@/helpers/lists/colors';
import SBIconList from '@/helpers/lists/sb-icon-list';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import { getLastOrgId } from '@/helpers/localStorage.helpers';

export default {
  name: 'AccountNav',
  mixins: [
    SettingsNavMixin,
    UserPermissionsMixin,
  ],
  beforeRouteEnter(to, from, next) {
    if (store.getters['organisation/currentOrganisation'].id && store.getters['organisation/organisationList'].length > 0) {
      next();
    } else if (store.getters['organisation/organisationList'].length > 0) {
      const lastOrganisationInFocus = getLastOrgId();
      const targetOrganisation = lastOrganisationInFocus ? store.getters['organisation/organisationList'].find(o => o.id === lastOrganisationInFocus) : null;

      if (targetOrganisation) {
        store.dispatch('organisation/fetchCurrentOrganisation', targetOrganisation.id);
      }

      next();
    }
  },
  props: {},
  data() {
    return {
      selectBranchActive: false,
      selectBranchHover: false,
      SBColors,
      SBIconList,
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisation: 'organisation/currentOrganisation',
      showAnnouncement: 'system/showAnnouncement',
    }),
  },
  mounted() {
    this.finalizeSplashView();
  },
  methods: {
    ...mapActions({
      finalizeSplashView: 'organisation/finalizeSplashView',
      fetchCurrentOrganisation: 'organisation/fetchCurrentOrganisation',
    }),
  },
};
</script>

<style lang="scss" scoped>
#settings-view {
  display: flex;
  width: 100%;
  background: $white;

  .settings-menu {
    // height: 100%;
    width: 100%;
    max-width: 261px;
    background: $white;
    padding: 12px;
    overflow: auto;
    border-right: 1px solid $greyBorderSecondary;

    .settings-subsection {
      display: block;
      margin-left: 24px;
    }

    h5 {
      font-size: 14px;
      font-weight: normal;
      line-height: 1.2;
      color: $blackUltralight;
      padding: 8px;
      margin: 22px 0 0 0;
      cursor: default;

      &:first-child {
        margin-top: 0;
      }
    }

    .branch-select {
      position: relative;
      margin-top: 23px;
      padding: 6px 8px;
      font-size: 14px;
      line-height: 1.2;
      color: $blackUltralight;
      cursor: pointer;
      border-radius: 5px;

      background-color: $greyChatBubble;

      &:first-child {
        margin-top: 0px;
      }

      .branch-icon {
        margin-right: 6px;
        // letter-spacing: 3px;
      }

      .sb-icon {
        transition: transform 0.2s ease;
      }

      &:hover, &.active {
        background-color: $greyChatBubble;
        * {
          color: $blackPrimary !important;
        }
      }

      &.active {
        .sb-icon {
          // TODO enable once we add it to all dropdowns
          // transform: rotateZ(180deg);
        }
      }
    }

    .list-item {
      margin: 6px 0 0 0;
      font-size: 14px;
      font-weight: normal;
      line-height: 1.2;
      padding: 6px 8px;
      border-radius: 5px;
      color: $blackPrimary;
      cursor: pointer;

      /* TODO - remove this class once all the settings items are implemented */
      &.not-implemented {
        color: $greyPrimary;
        &::after {
          content: " TODO";
          font-size: 8px;
          color: red;
        }
      }

      &:hover {
        background-color: $mainBg;
      }

      &.router-link-active {
        background-color: $bluePrimary;
        color: $white;
      }
    }
  }

  ::v-deep .settings-content {
    overflow: auto;
    padding: 0 40px;
    background: $white;

    /*
      Overrides due to a layout issue with clipped elements with negative margin.
      TODO - Fix this in rewrite.
    */
    &.no-margin {
      padding: 0px !important;

      .settings__title {
        padding-left: 40px;
        padding-right: 40px;
      }

      .response-items {
        // padding-left: 40px !important;
      }

      .response-preview {
        margin-right: 40px;
      }
    }
  }
}

::v-deep .list-item.router-link-exact-active .sb-icon .icon.mask {
  background-color: $white !important;
}
</style>
